export const InfoPanelContentProp = Object.freeze({
    Position: 'position',
    Text: 'text',
    TextIsBold: 'textIsBold',
    TextColor: 'textColor',
    IconName: 'iconName',
    IconColor: 'iconColor',
    IsHidden: 'isHidden',
});